import React from 'react'
import '../../scss/variables.scss'
import '../../scss/reset.scss'
import './Footer.scss'

import paypalIcon from '../../assets/images/Paypal_Icon.svg'
import LinkedInIcon from '../../assets/images/LinkedIn_Icon.svg'

function Footer() {
    return (
        <footer>
            <h1>Fady Meet</h1>
            <p>Copyright &copy; Fady 2021 - All rights reserved</p>
            <div className="socialIcons">
            <a href="https://www.paypal.com/paypalme/fadyorg" target="_blank" rel="noopener noreferrer">
                <img src={paypalIcon} alt="Paypal" />
            </a>
            <a href="https://www.linkedin.com/company/fady" target="_blank" rel="noopener noreferrer">
                <img src={LinkedInIcon} alt="LinkedIn" />
            </a>
            </div>
        </footer>
    )
}

export default Footer
